import {
  faArrowLeftLong,
  faGraduationCap,
  faCoins,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { baseURL, EDITTACADEMAC, UPDATE } from "../../../API/API";
import Lodingsubmit from "../../Loding/Loding";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Update() {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    academicName: "",
    academicType: "",
    sortOrder: 0,
    price: "",
    description: "",
    subtitle: "",
  });
  const [image, setImage] = useState(null);

  useEffect(() => {
    if (id) {
      axiosPrivate
        .get(`${baseURL}/${UPDATE}/${id}`)
        .then((res) => {
          const item = res.data?.data ?? {};
          setData({
            academicName: item.academicName || item.name || "",
            academicType: item.academicType || item.academic_type || "",
            sortOrder: item.sortOrder || item.sort_order || 0,
            price: item.price ?? "",
            description: item.description ?? "",
            subtitle: item.subtitle ?? "",
          });
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
          toast.error("حدث خطأ أثناء تحميل البيانات");
        });
    }
  }, [id, axiosPrivate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (saveAsDraft = false) => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("_method", "PUT");
      formData.append("academicName", data.academicName);
      formData.append("academicType", data.academicType);
      formData.append("sortOrder", data.sortOrder);
      formData.append("price", data.price);
      formData.append("description", data.description);
      formData.append("subtitle", data.subtitle);
      formData.append("save", saveAsDraft ? "1" : "0");
      if (image) {
        formData.append("image", image);
      }

      const response = await axiosPrivate.post(`${baseURL}/${EDITTACADEMAC}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("تم حفظ البيانات بنجاح");
      navigate("/DashboardLayout/content/academic");
    } catch (error) {
      console.error("حدث خطأ أثناء التعديل:", error);
      if (error.response && error.response.status === 400) {
        toast.error("لم تتمكن من حفظ البيانات لأن هذا الصف موجود من قبل");
      } else {
        toast.error("حدث خطأ أثناء التعديل، حاول مرة أخرى.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Lodingsubmit />}
      <ToastContainer position="top-center" reverseOrder={false} />

      <div className="p-4 content" dir="rtl">
        <Link
          style={{ display: "block", textAlign: "end" }}
          to="/DashboardLayout/content/academic"
        >
          <FontAwesomeIcon
            style={{ color: "var(--brand-200)" }}
            className="fw-bold fs-3"
            icon={faArrowLeftLong}
          />
        </Link>
        <h2 className="fw-bold">تعديل المرحلة دراسية</h2>
        <div className="d-flex align-items-center mb-5">
          <Form className="Form w-75" onSubmit={(e) => e.preventDefault()}>
            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="academicName"
                value={data.academicName}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faGraduationCap} />
                <span className="textinpout">اسم المرحلة</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="mb-5">
              <Form.Label>نوع المرحلة</Form.Label>
              <Form.Select
                required
                className="custom-select"
                name="academicType"
                value={data.academicType}
                onChange={handleChange}
              >
                <option value="">---</option>
                <option value="general">عام</option>
                <option value="azhar">ازهر</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="number"
                name="price"
                value={data.price}
                onChange={handleChange}
                placeholder=" "
                required
              />
              <Form.Label>
                <FontAwesomeIcon className="iconeForm" icon={faCoins} />
                <span className="textinpout">سعر المرحلة (الافتراضي: 150)</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="number"
                name="sortOrder"
                value={data.sortOrder}
                onChange={handleChange}
                placeholder=" "
                min="0"
              />
              <Form.Label>
                <span className="textinpout">ترتيب العرض</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                className="inpoutFeald"
                type="text"
                name="subtitle"
                value={data.subtitle}
                onChange={handleChange}
                placeholder=" "
              />
              <Form.Label>
                <span className="textinpout">العنوان الفرعي للمرحلة (مثال: ثانوي عام / ثانوية أزهرية) (اختياري)</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="floating-label-group mb-5">
              <Form.Control
                as="textarea"
                rows={3}
                className="inpoutFeald"
                name="description"
                value={data.description}
                onChange={handleChange}
                placeholder=" "
                style={{ height: "auto", paddingTop: "25px" }}
              />
              <Form.Label>
                <span className="textinpout">وصف المرحلة الدراسية (اختياري)</span>
              </Form.Label>
            </Form.Group>

            <Form.Group className="mb-5 text-end">
              <Form.Label className="small text-muted mb-2">تحديث صورة المرحلة الدراسية (اتركه فارغاً للاحتفاظ بالصورة الحالية):</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </Form.Group>

            <div className="d-flex gap-2">
              <Button
                onClick={() => handleSubmit(false)}
                className="custom-brand-btn-dhash"
              >
                حفظ
              </Button>

              <Button
                onClick={() => handleSubmit(true)}
                className="custom-reset-btn"
                style={{
                  backgroundColor: "transparent",
                  color: "black",
                }}
              >
                حفظ كمسودة
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}
